module.exports = __webpack_public_path__ + "img/notification.22832a1b.png";